import { createReducer, on } from '@ngrx/store';

import { Threats } from './models/Threats';
import * as actions from './threats.actions';

export const THREATS_FEATURE_KEY = 'threats';

export interface ThreatsState {
  threats: Threats[];
  isLoading: boolean;
}

export const initialState: ThreatsState = {
  threats: [],
  isLoading: false,
};

export const threatsReducer = createReducer(
  initialState,
  on(actions.getThreats, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getThreatsSuccess, (state, { threats }) => ({
    ...state,
    threats,
    isLoading: false,
  })),
);
